<template>
    <FontAwesomeIcon
        class="uik-icon"
        :icon="getIcon"
    />
</template>

<script>
import FontAwesomeIcon from "./FontAwesome/FontAwesomeIcon"

export default {
    name: "UikIcon",
    components: { FontAwesomeIcon },
    props: {
        icon: { type: [String, Array], default: "" },
        type: { type: String, default: "far" }
    },
    computed: {
        getIcon () {
            if (Array.isArray(this.icon)) return this.icon
            return [ this.type, this.icon ]
        }
    }
}
</script>
